import { setAccessToken } from '@service/user.service';
import { signParams } from '@yqz/base';
import axios, { AxiosRequestConfig } from 'axios';
import qs from 'qs';
import { isAccTokenExpired, refreshAccessToken } from '../utils';

const instance = axios.create({
  baseURL: process.env.REACT_APP_BINGOHOME_API,
  timeout: 8000,
  paramsSerializer: function (params) {
    const p = signParams({ ...params,pl_user: 'react_worker' }, process.env.REACT_APP_SECRET || '');
    return qs.stringify(p, { arrayFormat: 'repeat' });
  }
});

instance.interceptors.request.use(addToken);
let requestQueue = [] as { config: AxiosRequestConfig, resolve: Function }[];
async function addToken(config: AxiosRequestConfig) {
  const currentToken = window.accessToken;
  if (currentToken) {
    if (isAccTokenExpired(currentToken)) {
      console.log('token expired',window.isRefreshingToken);
      if (window.isRefreshingToken) {
        // add to queue
        return new Promise<AxiosRequestConfig>((resolve) => {
          requestQueue.push({ config, resolve })
        })
      } else {
        // refresh token
        window.isRefreshingToken = true;
        const newToken = await refreshAccessToken();
        window.isRefreshingToken = false;
        setAccessToken(newToken);
        onTonekRefreshed(newToken);
        return refreshConfig(config, newToken);
      }
    }
    else {
      // add token to header
      return refreshConfig(config, currentToken);
    }
  } else {
    return config;
  }

}

function refreshConfig(config: AxiosRequestConfig, newToken: string): AxiosRequestConfig {
  let newConfig = { ...config };
  if (newConfig.params?.accessToken) {
    newConfig.params.accessToken = newToken;
  }
  newConfig.headers.Authorization = `Bearer ${newToken}`;
  newConfig.headers['req_time'] = new Date().getTime();
  return newConfig;
}
function onTonekRefreshed(newToken: string) {
  requestQueue.forEach(
    request => {
      const newConfig = refreshConfig(request.config, newToken);
      request.resolve(newConfig);
    }
  );
}
export default instance;